import {
    analyticsEventInit,
    analyticsEventMenuClick,
    analyticsEventSizeChartClick,
    analyticsEventCustom,
    analyticsEventNewsletter,
    analyticsEventSearchLayer,
    analyticsEventExclusiveServicesClick,
    analyticsEventExclusiveServicesAppointmentClick,
    analyticsEventChangeLocale,
    analyticsUserData,
    analyticsProductImpression,
    analyticsEventInternalSearch,
    analyticsProductClick,
    analyticsDynamicPage,
    analyticsEventQuickCartAdd,
    analyticsEventWishlist,
    analyticsEventAddToCart,
    analyticsEventMinicartAddToCart,
    analyticsEventMinicartRemoveFromCart,
    analyticsFilters,
    analyticsEventLoadMore,
    analyticsEventCheckLocale,
    analyticsEventPromoView,
    analyticsEventPromoClick,
    analyticsEventWishlistShare,
    analyticsEventPwaPage,
    analyticsPaypalExpressStart,
    analyticsEventCloseLayer,
    analyticsEventMinicartLayer,
    analyticsEventVideo,
    analyticsEventWidget,
    analyticsEventCrossCategoryNavigationClick,
    analyticsEventTileImageCarouselSlideChange,
    analyticsGoToCart,
} from '_analytics/events'

/**
 * @name useAnalytics
 *
 * @description
 * Custom hook provides functions to track various analytics events.
 *
 * @hook
 * @returns {ReturnType<typeof useAnalytics>} An object containing functions to track analytics events.
 *
 * @example
 * ```tsx
 * const { analyticsEventMenuClick } = useAnalytics();
 *
 * analyticsEventMenuClick({});
 * ```
 */
const useAnalytics = () => {
    return {
        analyticsEventInit,
        analyticsEventCustom,
        analyticsEventMenuClick,
        analyticsEventSizeChartClick,
        analyticsEventNewsletter,
        analyticsEventSearchLayer,
        analyticsEventExclusiveServicesClick,
        analyticsEventExclusiveServicesAppointmentClick,
        analyticsEventChangeLocale,
        analyticsUserData,
        analyticsProductImpression,
        analyticsEventInternalSearch,
        analyticsProductClick,
        analyticsDynamicPage,
        analyticsEventQuickCartAdd,
        analyticsEventWishlist,
        analyticsEventAddToCart,
        analyticsEventMinicartAddToCart,
        analyticsEventMinicartRemoveFromCart,
        analyticsFilters,
        analyticsEventLoadMore,
        analyticsEventCheckLocale,
        analyticsEventPromoView,
        analyticsEventPromoClick,
        analyticsEventWishlistShare,
        analyticsEventPwaPage,
        analyticsPaypalExpressStart,
        analyticsEventCloseLayer,
        analyticsEventMinicartLayer,
        analyticsEventVideo,
        analyticsEventWidget,
        analyticsEventCrossCategoryNavigationClick,
        analyticsEventTileImageCarouselSlideChange,
        analyticsGoToCart,
    }
}

export {useAnalytics}
